import { ADD_USER, REMOVE_USER } from "./actions";

const initialUser = {
  user: null,
};

export const userReducer = (state = initialUser, action) => {
  switch (action.type) {
    case ADD_USER: {
      return {
        user: action.payload,
      };
    }
    case REMOVE_USER: {
      return {
        user: null,
      };
    }
    default: {
      return state;
    }
  }
};
